import { useEffect, useState } from "react";
import { Col, Row, Card } from "react-bootstrap"; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faStore, faUserSlash, faUserFriends } from '@fortawesome/free-solid-svg-icons'; // Import the icons
import BarChart from "../charts/apex-charts/BarChart";
import LineChart from "../charts/apex-charts/LineChart";
import SuperAdminHeader from "./Header";
import { api, superAdminReqConfig } from "../../include/api";
import '../../styles/SuperAdminDashboard.css';

const SuperAdminDashboard = () => {
    const [lastYearSalesData, setLastYearSalesData] = useState([]);
    const [lastYearOrderData, setLastYearOrderData] = useState({});
    const [counts, setCounts] = useState({});
    
    const currentYear = new Date().getFullYear();
    const lastYear = currentYear - 1;

    console.log(lastYearSalesData);
    console.log(lastYearOrderData);

    useEffect(() => {
        const fetchCounts = async () => {
            try {
                const response = await api.get('/dashboard_cards/', superAdminReqConfig());
                setCounts(response.data.data[0]); // Set the first item since it's an array
            } catch (error) {
                console.error("Error fetching sales data:", error);
            }
        };

        const fetchSalesData = async () => {
            try {
                const response = await api.get('/sales/', superAdminReqConfig());
                const salesData = response.data.data?.map(sale => sale.totalSales);
                console.log("Sales Data:", salesData); 
                setLastYearSalesData(salesData);
            } catch (error) {
                console.error("Error fetching sales data:", error);
            }
        };

        const fetchOrdersData = async () => {
            try {
                const response = await api.get('/product_for_year/', superAdminReqConfig());
                const ordersData = {};
                response.data.data.forEach(order => {
                    const productName = order.productName;
                    const monthYear = order.monthYear;
                    const quantity = order.totalQty;

                    if (!ordersData[productName]) {
                        ordersData[productName] = new Array(12).fill(0); 
                    }

                    const monthIndex = new Date(monthYear).getMonth();
                    ordersData[productName][monthIndex] += quantity;
                });
                console.log("Order Data:", ordersData); 
                setLastYearOrderData(ordersData);
            } catch (error) {
                console.error("Error fetching orders data:", error);
            }
        };

        fetchSalesData();
        fetchOrdersData();
        fetchCounts();
    }, []);

    return (
        <>
            <SuperAdminHeader>
                <div className="fixed-top-bar">
                    <h4 className="mx-18 my-5 p-2 fs-2">Dashboard</h4>

                    {/* Cards Section */}
                    <Row className="dashboard-cards-row mx-3">
                        <Col md={3} xs={6} className="mb-3">
                            <Card className="dashboard-card text-center">
                                <Card.Body>
                                    <FontAwesomeIcon icon={faUser} className="fa-icon" style={{ color: 'blue', fontSize: '2rem' }} />
                                    <Card.Title>
                                        <a href="/super/customer" style={{ textDecoration: 'none', color: 'inherit', fontSize:'28px' }}>Customers</a>
                                    </Card.Title>
                                    <Card.Text>{counts.customerCount || 0}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} xs={6} className="mb-3">
                            <Card className="dashboard-card text-center">
                                <Card.Body>
                                    <FontAwesomeIcon icon={faStore} className="fa-icon" style={{ color: 'blue', fontSize: '2rem' }} />
                                    <Card.Title>
                                        <a href="/super/shop" style={{ textDecoration: 'none', color: 'inherit', fontSize:'28px' }}>Shops</a>
                                    </Card.Title>
                                    <Card.Text>{counts.shopCount || 0}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} xs={6} className="mb-3">
                            <Card className="dashboard-card text-center">
                                <Card.Body>
                                    <FontAwesomeIcon icon={faUserSlash} className="fa-icon" style={{ color: 'blue', fontSize: '2rem' }} />
                                    <Card.Title>
                                        <a href="#" style={{ textDecoration: 'none', color: 'inherit', fontSize:'28px' }}>Inactive Users</a>
                                    </Card.Title>
                                    <Card.Text>{counts.inactiveUsers || 0}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={3} xs={6} className="mb-3">
                            <Card className="dashboard-card text-center">
                                <Card.Body>
                                    <FontAwesomeIcon icon={faUserFriends} className="fa-icon" style={{ color: 'blue', fontSize: '2rem' }} />
                                    <Card.Title>
                                        <a href="#" style={{ textDecoration: 'none', color: 'inherit', fontSize:'28px' }}>Very Active Users</a>
                                        </Card.Title>
                                    <Card.Text>{counts.veryActiveUsers || 0}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Bar Chart */}
                    <Row className="mx-3">
                        <Col xl={12}>
                            <div className="dashboard-chart-container">
                                <BarChart
                                    datasets={[{ name: 'Amt. Of Sales <b>₹</b>', data: lastYearSalesData }]}
                                    colors={['#FF4560']}
                                    labels={['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']}
                                    title={`Sales Overview for ${lastYear}`}
                                />
                            </div>
                        </Col>
                    </Row>

                    {/* Line Chart */}
                    <Row className="mx-3">
                        <Col xl={12} className="mb-5">
                            <div className="dashboard-chart-container">
                                <LineChart
                                    datasets={Object.keys(lastYearOrderData).map(product => ({
                                        name: product,
                                        data: lastYearOrderData[product],
                                    }))}
                                    colors={['#FF4560', '#4D47A2', '#DC2AAC', '#008FFB', '#FF9800']}
                                    labels={['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']}
                                    title={`Orders Overview for ${lastYear}`}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </SuperAdminHeader>
        </>
    );
};

export default SuperAdminDashboard;
